<template>
    <div class="container-fluid section">
        <div class="row heading">
            <div class="col-12 col-lg-3">
                <h2>Carriers List</h2>
            </div>

            <div class="col-12 col-lg-9 text-right">
                <div style="width: 250px; display: inline-block;">
                    <show-hide-cols
                        :cols="cols"
                        :selected="filters.columns"
                    ></show-hide-cols>
                </div>
                <save-report></save-report>

                <button class="btn btn-light" @click="clearFilters"><i class="fa fa-remove"></i> &nbsp;Clear Filters</button>&nbsp;


                <download
                    fn="carriers"
                    :filters="filters"
                    :cols="cols"
                ></download>
                &nbsp;&nbsp;
                <paginate
                        :page-count="num_pages"
                        :initial-page="parseInt(filters.page - 1)"
                        :page-range="1"
                        :margin-pages="1"
                        :click-handler="paginateClick"
                        container-class="pagination"
                        page-class="page-item"
                        page-link-class="page-link"
                        prev-class="page-item"
                        prev-link-class="page-link"
                        next-class="page-item"
                        next-link-class="page-link"
                ></paginate>
            </div>
        </div>

        <full-table
                headerClass="table-head"
                filterClass="table-filter table-subhead"
                :cols="cols"
                :data="tableData"
                filterInputClass="form-control"
                :filters="filters"
                @filter="fetch"
        >

            <template
                    v-for="col in cols"
                    v-if="meta && meta[col.key]"
                    :slot="col.key + '_heading'"
            >
                <span v-tooltip.bottom="metaValues(meta[col.key])">
                    {{ col.display }}
                    <i class="fa fa-info-circle" style="font-size: 12px;"></i>
                </span>
            </template>

            <template slot="total_mrc_filter" scope="props">

                <range-filter
                        v-model="filters.search.total_mrc"
                        label="%"
                >
                </range-filter>
            </template>

            <template slot="spiffrate_filter" scope="props">

                <range-filter
                        v-model="filters.search.spiffrate"
                        label="%"
                >
                </range-filter>
            </template>

            <template slot="commsrate_filter" scope="props">

                <range-filter
                        v-model="filters.search.commsrate"
                        label="%"
                >
                </range-filter>
            </template>

            <template slot="accounts_filter" scope="props">

                <range-filter
                        v-model="filters.search.accounts"
                >
                </range-filter>
            </template>


            <template slot="name_data" scope="props">
                <router-link :to="'carriers/' + props.data.carrier_id"> {{ props.value }} </router-link>
            </template>

            <template slot="commsrate_data" scope="props">
                <span v-if="props.index >= props.count">
                      <span v-if="props.value">
                          <span class="total-key">Avg</span>
                         <span class="total-value">{{props.value.average}}%</span>

                     </span>
                </span>
                <span v-else>
                    {{props.value}}%
                </span>
            </template>

            <template slot="spiffrate_data" scope="props">

                <span v-if="props.index >= props.count - 1">
                      <span v-if="props.value">
                          <span class="total-key">Avg</span>
                         <span class="total-value">{{props.value.average}}%</span>

                     </span>
                </span>
                <span v-else>
                    {{props.value}}%
                </span>

            </template>

            <template slot="total_mrc_data" scope="props">

                <span v-if="props.index >= props.count - 1">
                      <span v-if="props.value">
                         <span class="total-key">Total</span>
                         <span class="total-value">{{props.value.total | formatMoney}}</span>

                         <span class="total-key">Count</span>
                         <span class="total-value">{{props.value.count | formatInteger}}</span>

                         <span class="total-key">Avg</span>
                         <span class="total-value">{{props.value.average | formatMoney}}</span>

                     </span>
                </span>
                <span v-else>
                    {{props.value | formatMoney}}
                </span>



            </template>


            <pulse-loader style="text-align:center;" slot="loading" :loading="loading" color="#5e9cd3"></pulse-loader>

        </full-table>
    </div>
</template>

<script type="text/babel">
    var Paginate = require('vuejs-paginate');
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import FullTable from '../assets/FullTable.vue';
    import ShowHideCols from '../assets/ShowHideCols.vue';
    import SaveReport from '../assets/SaveReport.vue';
    import Download from '../assets/Download.vue';
    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
    import Timeframe from '../assets/Timeframe.vue';
    import RangeFilter from '../assets/RangeFilter.vue';
    import { metaData } from '../../mixins/metaData.js';
    export default {
        name: 'app',
        data () {
            return {
                styleObj:{
                    width: '320px',
                    textAlign: 'right'
                },
                filters: {
                    search:{
                        total_mrc: [null,null],
                        spiffrate: [null,null],
                        commsrate: [null,null],
                        accounts: [null,null]
                    },
                    sort: [],
                    columns:[],
                    limit: 25,
                    page: 1
                },
                num_pages: 0,
                cols:[
                    {
                        key:        'name',
                        display:    'Name',
                        filter:     true,
                        sortable:   true,
                        width:      300

                    },
                    {
                        key:        'commsrate',
                        display:    'Comms Rate',
                        filter:     "Array",
                        sortable:   true,
                        width:      300,
                        style: {
                            textAlign: 'right'
                        }

                    },
                    {
                        key:        'spiffrate',
                        display:    'Spiff Rate',
                        filter:     "Array",
                        sortable:   true,
                        width:      300,
                        style: {
                            textAlign: 'right'
                        }
                    },
                    {
                        key:        'accounts',
                        display:    '# of Accounts',
                        filter:     "Array",
                        sortable:   true,
                        width:      300,
                        style: {
                            textAlign: 'left'
                        }
                    },
                    {
                        key:        'total_mrc',
                        display:    'Total Mrc',
                        filter:     "Array",
                        sortable:   true,
                        width:      150,
                        style: {
                            textAlign: 'right'
                        }
                    }

                ],
                mrcs:[null,null],
                tableData:[],
                loading: false
            }
        },
        components:{
            Paginate,
            FullTable,
            PulseLoader,
            ShowHideCols,
            SaveReport,
            Download,
            DropdownConfirmation,
            Timeframe,
            RangeFilter

        },
        created(){},
        computed:{},
        filters:{
            formatMoney(val){
                if(!val) return ' - ';
                return "$" + val;
            },
        },
        mounted(){
            if(!this.userReport_id && localStorage.getItem('carrierFilters')){
                this.filters = JSON.parse(localStorage.getItem('carrierFilters'));
            }
        },
        methods:{
            setMrcs(){
                this.$set(this.filters.search.account_mrc, 0, this.mrcs[0]);
                this.$set(this.filters.search.account_mrc, 1, this.mrcs[1]);

            },
            paginateClick(pageNum){
                this.filters.page = pageNum;
            },
            fetch: _.debounce(function(filters){
                this.tableData = [];
                this.filters = Object.assign({}, filters);
                this.loading = true;
                var data = filters;
                this.timer = moment().valueOf();
                data.time = this.timer;
                data.offset = this.filters.limit * (this.filters.page - 1) || 0;
                data.limit = this.filters.limit;

                this.$send(this, 'carriers', data).then(r => {
                    this.loading = false;
                    if(r.time == this.timer){
                        this.tableData = r.carriers;
                        this.num_pages = r.count;

                        if(!_this.userReport_id){
                            localStorage.setItem('carrierFilters', JSON.stringify(_this.filters));
                        }


                    }
                });

            }, 400),
            clearFilters(){
                localStorage.setItem('accountFilters', '');
                this.resetFilters();
            },
            resetFilters(){
                this.filters = {
                    search:{
                        total_mrc: [null,null],
                        spiffrate: [null,null],
                        commsrate: [null,null],
                        accounts: [null,null]
                    },
                    sort: [],
                    columns:[],
                    limit: 25,
                    page: 1
                }
            }
        },
        mixins: [metaData]
    }
</script>


// WEBPACK FOOTER //
// CarrierIndex.vue?0893d879